import MilestonesToggleCompleteController from "../milestones/milestones-toggle-complete-controller";

export default class extends MilestonesToggleCompleteController {
  get eventName() {
    return "milestones:toggle-all-complete";
  }

  get eventDetail() {
    return { all: true, showComplete: this.showComplete };
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/projects/project-milestones-controller.js